<template>
  <b-card class="rounded-xl cust-header">
    <b-modal
      modal-content-classes="cust-modal-ht"
      header-bg-variant="primary"
      header-text-variant="white"
      id="cat-modal"
      title="Add Feature Category"
      hide-footer
      hide-header
    >
      <div class="flex justify-between items-center pb-4">
        <p class="text-xl font-semibold">Add feature Category</p>
      </div>
      <div class="mb-4">
        <p class="input-title text-black">Name</p>
        <base-input
          v-model="catName"
          placeholder="Enter feature title"
          class="md:border-0 lg:border-0 custipshadow"
          name="Title"
          :rules="{ required: true }"
        ></base-input>
      </div>
      <div class="flex justify-center">
        <b-button type="submit" variant="primary" @click="handleAddCat"
          >Save</b-button
        >
        <b-button
          type="submit"
          variant="primary"
          @click="closeModal('cat-modal')"
          >Close</b-button
        >
      </div>
    </b-modal>
    
    <b-modal
      modal-content-classes="cust-modal-ht"
      header-bg-variant="primary"
      header-text-variant="white"
      id="modal-7"
      title="Edit Feature"
      hide-footer
      hide-header
    >
      <div class="flex justify-between items-center pb-4">
        <p class="text-xl font-semibold">Edit Feature</p>
        <!-- <img
          src="../../../../assets/images/cross.png"
          class="h-8 w-8 cursor-pointer"
          alt="cross"
          v-b-modal.editModal
        /> -->
      </div>
      <div class="mb-4">
        <p class="input-title text-black">Title</p>
        <base-input
          v-model="editTitle"
          placeholder="Enter feature title"
          class="md:border-0 lg:border-0 custipshadow"
          name="Title"
          :rules="{ required: true }"
        ></base-input>
      </div>
      <div class="mb-4">
        <p class="input-title text-black">Category</p>
        <b-form-select
          v-model="editCategory"
          placeholder="Select"
          class="w-full"
          required
        >
          <b-form-select-option
            v-for="item in getAllCategory"
            class="py-5"
            :key="item._id"
            :label="item.name"
            :value="item._id"
          >
          </b-form-select-option>
        </b-form-select>
      </div>
      <div class="mb-4">
        <p class="input-title text-black">Description</p>
        <base-input
          v-model="editDesc"
          placeholder="Enter feature description"
          class="md:border-0 lg:border-0 custipshadow"
          name="Description"
          :rules="{ required: true }"
        ></base-input>
      </div>
      <div class="flex justify-center">
        <b-button type="submit" variant="primary" @click="editFeature()"
          >Save</b-button
        >
        <b-button type="submit" variant="primary" @click="closeModal('modal-7')"
          >Close</b-button
        >
      </div>
    </b-modal>
    <div class="flex justify-between items-center">
      <div>
        <h2 class="text-2xl font-semibold">Add Category</h2>
        <!-- 
        <small class=" text-muted "
          >Lorem ipsum dolor sit amet, consectetur adipiscing elit,
        </small> -->
      </div>
      <div class="flex justify-between items-center">
        <!-- <base-button
          outline
          type="primary"
          class="flex px-3 py-1 mx-1"
          v-b-modal.modal-6
        >
          <feather-icon icon="PlusIcon" class="mr-1"></feather-icon> Add Feature
        </base-button> -->
        <base-button
          outline
          type="primary"
          class="flex px-3 py-1 mx-1"
          v-b-modal.cat-modal
        >
          <feather-icon icon="PlusIcon" class="mr-1"></feather-icon> Add
          Category
        </base-button>
      </div>
    </div>

    <b-input-group class="mt-12">
      <b-form-input
        class="border-none shadow-lg"
        type="text"
        min="0.00"
        placeholder="Enter Search...."
        v-model="search"
        @keyup="searchData()"
      ></b-form-input>

      <b-input-group-append>
        <b-button
          variant="white"
          class="flex items-center shadow-lg"
          aria-label="search"
        >
          <feather-icon
            class="cursor-pointer mr-2"
            icon="SearchIcon"
            svgClasses="w-4 h-4"
          ></feather-icon>
        </b-button>
      </b-input-group-append>
    </b-input-group>
    <el-table
      class="table-responsive table-flush mt-6 cust-overflow-x-primary-color"
      header-row-class-name="thead-light table-th-color"
      :data="getAllFeatures.featureRecord"
    >
      <el-table-column
        label="Sr. No"
        type="index"
        :index="indexMethod"
        width="80px"
      ></el-table-column>
      
      <el-table-column
        label="Category"
        prop="category"
        min-width="150px"
        sortable
      >
        <template v-slot="{ row }">
          <span class="text-black font-medium">{{
            row.category ? row.category.name : "-"
          }}</span>
        </template>
      </el-table-column>

      <el-table-column label="Action" min-width="30px">
        <template v-slot="{ row }">
          <div class="flex items-center cursor-pointer">
            <feather-icon
              icon="EditIcon"
              svgClasses="w-5 cursor-pointer"
              class="mr-2"
              @click="handleEdit(row)"
            ></feather-icon>
            <feather-icon
              icon="TrashIcon"
              svgClasses="w-5"
              data-toggle="tooltip"
              data-placement="top"
              @click="deleteFeature(row)"
              title="Delete"
            ></feather-icon>
          </div>
        </template>
      </el-table-column>
    </el-table>

    <b-card-footer class="py-4 d-flex justify-content-end">
      <base-pagination
        @change="handlePageChange"
        v-model="currentPage"
        :per-page="perPage"
        :total="total_row"
      ></base-pagination>
    </b-card-footer>
  </b-card>
</template>
<script>
import "../../scss/Index.scss";
import { mapState } from "vuex";

import {
  Table,
  TableColumn,
  DropdownMenu,
  DropdownItem,
  Dropdown,
} from "element-ui";
export default {
  name: "light-table",
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
  },
  data() {
    return {
      title: "",
      catName: "",
      category: "",
      description: "",
      editTitle: "",
      editCategory: "",
      editDesc: "",
      featureId: "",
      CategoryData,
      currentPage: 1,
      editModal: false,
      openAddBannerSidebar: false,
      perPage: 5,
      total_row: 1,
      search: "",
      headingOptions: [
        { name: "About", value: "About" },
        { name: "Information", value: "Information" },
        { name: "Community", value: "Community" },
        { name: "Learning", value: "Learning" },
        { name: "Productivity", value: "Productivity" },
        { name: "Marketplace", value: "Marketplace" },
      ],
    };
  },
  methods: {
    indexMethod(index) {
      return this.perPage * (this.currentPage - 1) + index + 1;
    },

    closeModal(name) {
      this.resetForm();
      this.$bvModal.hide(name);
    },

    async handleCreate() {
      let payload = {
        title: this.title,
        description: this.description,
        category: this.category,
      };
      let loader = this.$loading();
      try {
        let data = await this.$store.dispatch(
          "subscribe/CreateFeatures",
          payload
        );
        loader.close();
        if (data.code === 200) {
          this.dataLoad();
          this.closeModal("modal-6");
          await this.$swal.fire({
            text: "Your new feature has been successfully added!",
            icon: "success",
            confirmButtonText: "Okay",
            confirmButtonColor: "#830c81",
            showCancelButton: false,
          });
        }
        this.resetForm();
      } catch (error) {
        // console.log(error);
        loader.close();

        if (error.response.status == 400) {
          this.$router.push({ name: "signin" });
          this.$swal.fire({
            title: "Session Expired",
            text: "Your session has ended and for security reasons, we request you to login again",
            icon: "warning",
            confirmButtonColor: "#830c81",
            showCancelButton: false,
          });
          loader.close();
        } else if (error.response.status == 409) {
          loader.close();
          this.$swal.fire({
            text: error.response.data.message,
            icon: "error",
            confirmButtonColor: "#830c81",
            showCancelButton: false,
          });
        } else if (error) {
          loader.close();
          this.$swal.fire({
            text: "Something went wrong",
            icon: "error",
            confirmButtonColor: "#830c81",
            showCancelButton: false,
          });
        }
      }
    },

    handleEdit(item) {
      this.$bvModal.show("modal-7");
      this.editTitle = item.title;
      this.editDesc = item.description;
      this.editCategory = item.category._id;
      this.featureId = item._id;
    },
    async editFeature() {
      console.log(this.editCategory, "///");
      let payload = {
        _id: this.featureId,
        title: this.editTitle,
        description: this.editDesc,
        category: this.editCategory,
      };
      let loader = this.$loading();
      try {
        let data = await this.$store.dispatch(
          "subscribe/UpdateFeatures",
          payload
        );
        loader.close();
        if (data.code === 200) {
          this.dataLoad();
          this.closeModal("modal-7");
          await this.$swal.fire({
            text: "Your feature has been successfully updated!",
            icon: "success",
            confirmButtonText: "Okay",
            confirmButtonColor: "#830c81",
            showCancelButton: false,
          });
        }
      } catch (error) {
        console.log(error);
        if (error.response.status == 400) {
          this.$router.push({ name: "signin" });
          this.$swal.fire({
            title: "Session Expired",
            text: "Your session has ended and for security reasons, we request you to login again",
            icon: "warning",
            confirmButtonColor: "#830c81",
            showCancelButton: false,
          });
          loader.close();
        } else if (error.response.status == 409) {
          loader.close();
          this.$swal.fire({
            text: error.response.data.message,
            icon: "error",
            confirmButtonColor: "#830c81",
            showCancelButton: false,
          });
        } else if (error) {
          loader.close();
          this.$swal("", "Something went wrong", "error");
        }
      }
    },

    async dataLoad() {
      let payload = {
        offset: (this.currentPage - 1) * 5,
        limit: 5,
        search: this.search,
      };
      try {
        let data = await this.$store.dispatch(
          "subscribe/GetAllFeatures",
          payload
        );
        await this.$store.dispatch("subscribe/getCategory");
        this.total_row = data.data.recordCount;
        // console.log(this.total_row);
      } catch (error) {
        console.log(error);
      }
    },
    async handleAddCat() {
      let payload = {
        name: this.catName,
      };
      try {
        await this.$store.dispatch("subscribe/addCategory", payload);
        this.closeModal("cat-modal");
        this.catName = "";
        this.dataLoad();
      } catch (error) {}
    },
    async searchData() {
      await this.dataLoad();
    },

    resetForm() {
      this.title = "";
      this.description = "";
    },

    handlePageChange(value) {
      this.currentPage = value;
      try {
        this.dataLoad();
      } catch (error) {}
    },

    async deleteFeature(val) {
      // console.log(val._id);
      let payload = {
        _id: val._id,
      };
      let loader = this.$loading();
      try {
        this.$swal
          .fire({
            title: "Are you sure?",
            html: "<p style='text-align:center'>You won't be able to revert this!</p>",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#830c81",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes, delete it!",
          })
          .then(async (result) => {
            if (result.value == true) {
              await this.$store.dispatch("subscribe/DeleteFeatures", payload);
              this.dataLoad();
            } else {
              this.dataLoad();
            }
          });
        loader.close();
      } catch (error) {
        console.log(error);
      }
    },
  },

  mounted() {
    this.dataLoad();
  },
  computed: {
    ...mapState("subscribe", {
      getCoupon: "getCoupon",
      getAllFeatures: "getAllFeatures",
      getAllCategory: "getAllCategory",
    }),
  },
};
</script>

<style scoped>
.swal-modal .swal-text {
  text-align: center;
}
.cust-modal-ht header h5 {
  color: #fff !important;
}
</style>
